import { Stack, styled } from "@mui/material";

export const BaseCard = styled(Stack)(({ theme }) => ({
  boxShadow: "0px 1px 30px 0px rgba(16, 24, 40, 0.05)",
  borderRadius: "1rem",
  background: theme.palette.background.default,
  flex: 1,
  mx: 2,
  width: "36.5625rem",
}));
